module.exports = __webpack_public_path__ + "mn.024b272e783bd70b5cb2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mn.svg
// module chunks = styles